import { css } from 'styled-components'
import mediaQuery from 'styles/mediaQuery'

export const magicContainerStyle = css`
  width: 1140px;
  padding: 0 15px;
  margin: 0 auto;
  max-width: 100%;
`

export const magicContainer2Style = css`
  width: 700px;
  margin: 0 auto;
  max-width: 100%;
`

export const magicContainerFullStyle = css`
  width: 100%;
  padding: 0;
  margin: 0 auto;
`

export const headerMainStyle = css`
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  ${mediaQuery.desktopMin} {
    font-size: 40px;
  }
`

export const textMainStyle = css`
  font-size: 14px;
  line-height: 160%;
  ${mediaQuery.desktopMin} {
    font-size: 18px;
  }
`

const headerStyle = css`
  font-weight: 600;
  font-size: 28px;
  line-height: 120%;
  ${mediaQuery.desktopMin} {
    font-size: 36px;
  }
`

export const headerBlackStyle = css`
  ${headerStyle};
  color: #191919;
`

export const headerWhiteStyle = css`
  ${headerStyle};
  color: #faf9f6;
`

export const header2Style = css`
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
`
export const header2BlackStyle = css`
  ${header2Style};
  color: #191919;
`
export const header2WhiteStyle = css`
  ${header2Style};
  color: #faf9f6;
`

export const text1Style = css`
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
`

export const text1GrayStyle = css`
  ${text1Style};
  color: #8d8f98;
`

export const text2Style = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
`

export const text2WhiteStyle = css`
  ${text2Style};
  color: #faf9f6;
`

export const text2GrayStyle = css`
  ${text2Style};
  color: #8d8f98;
`

const buttonStyle = css`
  height: 44px;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  transition: 0.3s;
  &:hover {
    opacity: 0.85;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 10px;
  }
`

export const bigButtonStyle = css`
  height: auto;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  color: var(--black-carbon);

  ${mediaQuery.tabletMin} {
    padding: 19px 36px;
    font-size: 19px;
  }
  ${mediaQuery.desktopMin} {
    padding: 21px 42.5px;
    font-size: 22px;
    min-width: 220px;
  }
`

export const buttonPurpleStyle = css`
  ${buttonStyle};
  background: linear-gradient(94.96deg, #f26bcd 8.93%, #c567f4 94.95%);
  color: #faf9f6;
`

export const buttonGreenStyle = css`
  ${buttonStyle};
  background-color: var(--green-main);
  color: black;
`
export const buttonOffWhiteDarkStyle = css`
  ${buttonStyle};
  background-color: var(--off-white-dark);
  color: var(--black-carbon);
`

export const buttonBlackStyle = css`
  ${buttonStyle};
  background: #191919;
  color: #faf9f6;
`

export const buttonWhiteStyle = css`
  ${buttonStyle};
  background: #faf9f6;
  color: #191919;
`

export const buttonBlackBorder = css`
  ${buttonStyle};
  border: 1px solid #191919;
  background: transparent;
  color: #191919;
`

export const listDropStyle = css`
  &:before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    background: #8d8f98;
    transform: translateY(-50%);
    ${mediaQuery.mobile} {
      top: 12px;
    }
  }
`
